<div class="input-field">
  <span class="label">{{ label }}</span>
  <div class="input-wrapper">
    <input
      [(ngModel)]="inputData"
      [disabled]="disabled"
      [type]="type"
      [placeholder]="placeholder"
      (keyup)="onKeyUp($event)"
      (keyup.enter)="onEnter()"
      #passwordField
    />
    <img
      class="eye-hidden point"
      *ngIf="passwordField.type == 'text' && this.label == 'Password'"
      (click)="passwordField.type = 'password'"
      src="../../../assets/icons/eye-hidden.svg"
      alt=""
    />
    <i
      nz-icon
      nzType="eye"
      nzTheme="outline"
      *ngIf="passwordField.type.includes('password') && this.label == 'Password'"
      (click)="passwordField.type = 'text'"
    ></i>
  </div>
</div>
